import React from "react";
import { useWindowDimensions } from "@app/hooks";
import CurrencyModalHeader from "./CurrencyModalHeader.tsx";
import CurrencyModalBody from "./CurrencyModalBody.tsx";
import { LanguageModalWrapper } from "./styles";

const CurrencyModal = ({ closeModal }: any) => {
  const { width: w, height } = useWindowDimensions();

  return (
    <LanguageModalWrapper
      style={{ height: '100%', minHeight: 230, width: '100%'}}
    >
      <CurrencyModalHeader closeModal={closeModal} />
      <CurrencyModalBody closeModal={closeModal} />
    </LanguageModalWrapper>
  );
};

export default CurrencyModal;
